import Pagination from '../Pagination/index';

export default {
    meditations: null,
    error: '',
    meditation: null,
};
